import { render, staticRenderFns } from "./login-panel.vue?vue&type=template&id=fffbb374&"
import script from "./login-panel.vue?vue&type=script&lang=js&"
export * from "./login-panel.vue?vue&type=script&lang=js&"
import style0 from "./login-panel.vue?vue&type=style&index=0&id=fffbb374&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports